import { Button, Nav } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import Headerbenner from './../../images/shoe.jpg'
import { Link } from 'react-router-dom';

const Home = () => {
  const [reviews,setReviews] =useState([]);

    useEffect( () => {
        fetch('./Reviews.JSON')
        .then(res=>res.json())
        .then(data=>setReviews(data))
    },[])
    return (
        <div>
           <div className="container">
           <div className="row mt-5 d-flex align-items-center">
                <div className="col-12 col-md-6">
                   <h1 style={{color:'#2a5568'}}>Save Shopping My Online shope</h1> 
                   <p>With a focus on personalized shopping and thousands of styles from top brands, we strive to match our customers with the perfect pair. At Shoes.com, we offer a curated assortment of footwear and accessories for the on-the-go lifestyle, specializing in athletic, comfort and casual footwear for the whole family. Founded in 1999, Shoes.com is the original online shopping destination for dependable footwear and unmatched value. Today, we continue our legacy of exceptional service, while offering a convenient and easy-to-navigate shopping experience.</p>
                   <Button style={{background:'#2a5568'}} variant="secondary" size="sm m-auto fw-bold">
                      Explore Now
                    </Button>
                </div>
                <div className="col-12 col-md-6">
                  <img src={Headerbenner} alt="" />
                </div>
            </div>
           </div>

          
           <div className="container mt-4">
           <h2  style={{color:'#2a5568'}}>Customer reviews</h2>
               <div className="row row-cols-1 row-cols-md-3 g-4 mt-4">
                  {
                      reviews.slice(3).map(review=><div key={review.id} class="col">
                      <div style={{height:'350px'}} class="card">
                        <img src={review.img} style={{height:'200px' , width:'200px'}} className='card-img-top m-auto rounded-circle' alt="" />
                        <div className="card-body">
                          <h6 class="card-title">Customer Name: {review.CustomerName}</h6>
                          <p className="card-text">Comments: {review.Des}</p>
                          <p class="card-text">Rating: {review.rating}</p>  
                        </div>
                      </div>
                    </div>)
                  }
      
               </div>
               <Button className='mt-3 mb-2 border-0' style={{background:'#2a5568'}} variant="primary" size="md">
                 <Nav.Link  className='text-white'  as= {Link} to="/review">View All Reviews</Nav.Link>
                     </Button>
           </div>
        </div>
    );
};

export default Home;